import React from 'react';
import { useWidgetViewModel } from '../hooks/useWidgetViewModel';
import { classes } from './Body.st.css';
import { ServiceCard } from './ServiceCard/ServiceCard';
import { EmptyState } from './EmptyState/EmptyState';

export const Body = () => {
  const {
    bodyViewModel: { services },
  } = useWidgetViewModel();

  return (
    <div className={classes.root}>
      {services.length === 0 && <EmptyState />}
      <ul className={classes.servicesGrid}>
        {services.map((service, index) => (
          <li className={classes.serviceWrapper} key={service.id}>
            <ServiceCard service={service} index={index} />
          </li>
        ))}
      </ul>
    </div>
  );
};
